function main() {
  const projectContainer = document.querySelectorAll('.project-container');
  const detailsContainer = document.querySelectorAll(
    '.project-details-container'
  );
  let elemHeight = 0;

  if (window.innerWidth > 768) {
    detailsContainer.forEach(elem => {
      elem.style.height = 'unset';
      if (elem.clientHeight > elemHeight) {
        elemHeight = elem.clientHeight;
      }
    });

    detailsContainer.forEach(elem => {
      elem.style.height = elemHeight + 'px';
    });
  }

  for (let i = 0; i < projectContainer.length; i++) {
    projectContainer[i].style.marginBottom =
      detailsContainer[i].offsetHeight + 'px';
  }
}
export default main;
